import { render, staticRenderFns } from "./ProcureGoods.vue?vue&type=template&id=a6169b78&scoped=true"
import script from "./ProcureGoods.vue?vue&type=script&lang=js"
export * from "./ProcureGoods.vue?vue&type=script&lang=js"
import style0 from "./ProcureGoods.vue?vue&type=style&index=0&id=a6169b78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6169b78",
  null
  
)

export default component.exports